import { useState } from "react";
import { RiDeleteBin6Line, RiDeviceRecoverLine } from "react-icons/ri";
import { useSelector } from "react-redux";
import { FORMS, MODULES } from "../../const";

const CategoryCard = ({
  icon,
  title,
  description,
  onHover,
  views,
  recover = false,
  isVideo = false,
  docCount = 0,
  onClick = () => {},
  onDeleteClick = () => {},
  onRecoverClick = () => {},
}) => {
  const auth = useSelector((state) => state.user.permissions[MODULES?.Master]);
 const helpCenterPermission = auth?.[FORMS?.HELP_CENTER?.HELP_CENTER?.form] ?? {};
  console.log("helpCenterPermission", helpCenterPermission);
  const createArticlePermission =
    helpCenterPermission?.[FORMS?.HELP_CENTER?.INFO?.form]?.CREATE;
  const deleteArticlePermission =
    helpCenterPermission?.[FORMS?.HELP_CENTER?.INFO?.form]?.DELETE;
  const updateArticlePermission =
    helpCenterPermission?.[FORMS?.HELP_CENTER?.INFO?.form]?.UPDATE;
  const viewArticlePermission =
    helpCenterPermission?.[FORMS?.HELP_CENTER?.INFO?.form]?.VIEW;
  const [hovered, setHovered] = useState(false);

  const handleMouseEnter = () => {
    setHovered(true);
    if (onHover) onHover(title);
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  return (
      <div
        className={`category-card ${hovered ? "hovered" : ""}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={onClick}
      >
        <div className="icon-box">{icon}</div>
        <div className="text-box">
          <h2>{title}</h2>
          <p>{description}</p>
        </div>
        <span className="views">{views + " views"}</span>

        <span className="doc-count">{docCount + " files attached"}</span>
        <span className="video-count">{`${isVideo ? "video attached " : ""}`}</span>

        {deleteArticlePermission && recover === false && (
          <RiDeleteBin6Line
            className="delete-icon"
            size={20}
            onClick={(e) => {
              e.stopPropagation();
              onDeleteClick();
            }}
          />
        )}

        {updateArticlePermission && recover === true && (
          <RiDeviceRecoverLine
            className="recover-icon"
            size={25}
            onClick={(e) => {
              e.stopPropagation();
              onRecoverClick();
            }}
          />
        )}
      </div>
  );
};

export default CategoryCard;
